import helper from './tool'
const use = {
    mobileShieldSign: function (keys) {
        let re = ''
        console.log('2=============');
        window.signatureData = function (val) {
            console.log('4=============');
            console.log('执行signatureData')
            console.log('val: ' + val)
            re = val
        }
        //mobileShieldSign
        helper.callModule("mobileShieldSign", JSON.stringify(keys));
        console.log('3=============');
        console.log('ree: ' + re)
        return re



    }
};
export default use